import { Navigate } from "react-router-dom";
import useAuth from "./useAuth";
import { useSelector } from "react-redux";

export default function PublicRoute({ children }) {
  const { user } = useSelector((state) => state.auth);
  const isLoggedIn = useAuth();

  return !isLoggedIn ? (
    children
  ) : (
    <Navigate
      to={`/${user?.role === "student" ? "course-player" : "dashboard"}`}
    />
  );
}
